<app-progress-spinner [enabled]="loading()" />

<div class="dialog">
  @if (!loading()) {
    <header class="title">
      {{ this.facility()?.facilityName ?? '' }}
      {{ 'LOCATION.LABEL.VISITORS_LOG' | translate }}
    </header>
    @if (!queryErrored()) {
      @if (activeVisitors().length > 0) {
        <div class="table-container">
          <p-table [value]="activeVisitors()">
            <ng-template #header>
              <tr>
                <th>{{ 'OPMONITORING.LABEL.VISITOR_NAME' | translate }}</th>
                <th>{{ 'LOCATION.LABEL.COMPANY' | translate }}</th>
                <th>{{ 'CONTACT.LABEL.CONTACT_NUMBER' | translate }}</th>
                <th>{{ 'OPMONITORING.LABEL.SIGN_IN_TIME' | translate }}</th>
                <th>{{ 'COMMON.LABEL.ACTIONS' | translate }}</th>
              </tr>
            </ng-template>
            <ng-template #body let-visitor>
              <tr>
                <td>{{ visitor.name }}</td>
                <td>{{ visitor.company }}</td>
                <td>{{ visitor.contactNumber }}</td>
                <td>
                  {{ visitor.signInTime | date: 'yyyy-MM-dd hh:mm:ss aaa' }}
                </td>
                <td>
                  <button
                    pButton
                    type="button"
                    [label]="'LOCATION.LABEL.BUTTONS.SIGN_OUT' | translate"
                    (click)="requestSignOut(visitor)"
                    [disabled]="
                      !hasResolvedFacilityIdentity() || isSigningOut(visitor.id)
                    "
                    [loading]="isSigningOut(visitor.id)"
                  ></button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      } @else {
        <p class="empty-state">
          {{ 'LOCATION.MESSAGES.INFO.NO_ACTIVE_VISITORS' | translate }}
        </p>
      }
    } @else {
      <p class="empty-state">
        {{ 'LOCATION.MESSAGES.ERROR.ERROR_LOADING_OR_NO_ACCESS' | translate }}
      </p>
    }
  }
</div>
